/* RESPONSIBLE TEAM: team-workflows */
import type Fin from 'embercom/models/operator/visual-builder/step/fin';
import StepConfig, { type StepConfigParams } from '../step';
// eslint-disable-next-line no-restricted-imports
import containerLookup from 'embercom/lib/container-lookup';

export default class FinConfiguration extends StepConfig {
  declare step: Fin;
  appService: any;
  triggerDeleteFinModalCallback?: () => void;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/fin',
      ...params,
    });

    this.appService = containerLookup('service:appService');
  }

  get showChannelTypeHeaders(): boolean {
    return true;
  }

  get showFinPreHandoverSection(): boolean {
    return true;
  }

  get showFinCsatSection(): boolean {
    return true;
  }

  get showFinAutoCloseSection(): boolean {
    return true;
  }

  get showMessengerSettings(): boolean {
    return false;
  }

  get showFollowUpSettings(): boolean {
    return true;
  }

  get showConfirmResolutionSettings(): boolean {
    return false;
  }

  get showHandoffToExternalTicketOnResolutionSection(): boolean {
    return false;
  }

  get showFinSetExpectationsSection(): boolean {
    return true;
  }

  get stepMenuConfigOptions() {
    return [
      {
        icon: 'trash',
        text: this.intl.t('operator.workflows.visual-builder.delete'),
        isDisabled: !this.canDeleteStep,
        tooltipText: this.deleteTooltipText,
        dataTest: 'fin-step-menu-delete',
        onSelectItem: () => {
          this.triggerDeleteFinModalCallback?.();
        },
      },
    ];
  }
}

export class StandaloneIntercomMessagingFinStepConfig extends FinConfiguration {
  get showChannelTypeHeaders(): boolean {
    return false;
  }

  get showMessengerSettings(): boolean {
    return true;
  }

  get showConfirmResolutionSettings(): boolean {
    return true;
  }

  get showHandoffToExternalTicketOnResolutionSection(): boolean {
    return true;
  }
}

export class StandaloneMessagingFinStepConfig extends FinConfiguration {
  get showChannelTypeHeaders(): boolean {
    return false;
  }

  get showConfirmResolutionSettings(): boolean {
    return true;
  }

  get showHandoffToExternalTicketOnResolutionSection(): boolean {
    return true;
  }
}

export class StandaloneTicketFinStepConfig extends FinConfiguration {
  get showChannelTypeHeaders(): boolean {
    return false;
  }

  get showFinPreHandoverSection(): boolean {
    return false;
  }

  get showFinCsatSection(): boolean {
    return false;
  }

  get showConfirmResolutionSettings(): boolean {
    return false;
  }

  get showHandoffToExternalTicketOnResolutionSection(): boolean {
    return false;
  }
}

export class StandaloneZendeskTicketFinStepConfig extends FinConfiguration {
  get showChannelTypeHeaders(): boolean {
    return false;
  }

  get showFinPreHandoverSection(): boolean {
    return false;
  }

  get showConfirmResolutionSettings(): boolean {
    return false;
  }

  get showHandoffToExternalTicketOnResolutionSection(): boolean {
    return false;
  }

  get showFinSetExpectationsSection(): boolean {
    return false;
  }
}
